export default {"src":"/_next/static/media/google.47763f5c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};